import { UserSecretBase } from "domain/model/base";

export default class UserSecret extends UserSecretBase {};
